import i18n from 'client/i18n'
import { createSearch } from 'src/editor/shared/entities/search/create-search'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'
import { RootEntityInterface } from 'src/shared/schemas/base-entity.schema'
import { ContainerBaseEntityUnionInterface } from 'src/shared/schemas/container-base-entity.schema'
import { createBaseStructure } from 'src/shared/utils/base-structure-generator'

export const createSearchFromLibrary = (
  container: ContainerBaseEntityUnionInterface | RootEntityInterface,
  locale: string,
  position = 0,
) => {
  const fixedT = i18n.getFixedT(locale)

  const { structure, descendantEntity } = createBaseStructure(
    container,
    position,
  )

  const search = createSearch(
    descendantEntity.id,
    descendantEntity.masterBlockId,
  )

  search.input.placeholder = fixedT('components.search.placeholder')
  search.seeMore.text = fixedT('components.search.see_more')

  return {
    ...structure,
    [descendantEntity.id]: {
      ...descendantEntity,
      childIds: insertChild(descendantEntity.childIds, search.id, position),
    },
    [search.id]: search,
  }
}
